import { render, staticRenderFns } from "./RectoplusPagination.vue?vue&type=template&id=14cdf783&"
import script from "./RectoplusPagination.vue?vue&type=script&lang=js&"
export * from "./RectoplusPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports